// assets
import { 
  IconUsers, 
  IconUserPlus, 
  IconMessageCircle, 
  IconFileText, 
  IconUserX, 
  IconUserMinus, 
  IconUserShare, 
  IconReorder, 
  IconReport,
  IconHierarchy2, 
  IconFileTypePdf, 
  IconReplaceUser,
  IconSchool
} from '@tabler/icons-react';

// constant
const icons = {
  IconUsers,
  IconUserPlus,
  IconFileText,
  IconUserMinus,
  IconUserX,
  IconMessageCircle,
  IconUserShare,
  IconReorder,
  IconReport,
  IconFileTypePdf,
  IconReplaceUser,
  IconHierarchy2,
  IconSchool
};

const userRole = localStorage.getItem('userRole');
const userPosition = localStorage.getItem('userPosition');

// ==============================|| EMPLOYEES MENU ITEMS ||============================== //

const employees = {
  id: 'employees',
  title: 'Employees',
  type: 'group',
  children: []
};

if (userRole === 'MANAGER' || userRole === 'HR' || userRole === 'DIRECTOR' || userRole === 'DEV') {
  employees.children.push(
    {
      id: 'Overview',
      title: 'Employees',
      type: 'item',
      url: '/employees',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    ...(((userRole === 'MANAGER' || userRole === 'HR') && userPosition === 'Project Manager')
      ? [{
          id: 'myTeam',
          title: 'My Team',
          type: 'item',
          url: '/my-team',
          icon: icons.IconUsers,
          breadcrumbs: false
        }]
      : []),
    {
      id: 'employees-contract',
      title: 'Contracts & Salaries',
      type: 'item',
      url: '/contract',
      icon: icons.IconFileText,
      breadcrumbs: false
    },
    /* {
      id: 'organization-chart',
      title: 'Organization Chart',
      type: 'item',
      url: '/chart',
      icon: icons.IconHierarchy2,
      breadcrumbs: false
    }, */
    // ✅ Added: Inactive Employees
    /* {
      id: 'history-management',
      title: 'History Management',
      type: 'item',
      url: '/history-management',
      icon: icons.IconClipboardList,
      breadcrumbs: false,
    }, */
    
    {
      id: 'employees-career',
      title: 'Employees Career',
      type: 'item',
      url: '/employees-career',
      icon: icons.IconReport,
      breadcrumbs: false
    },
    {
      id: 'offboarding',
      title: 'Offboarding',
      type: 'item',
      url: '/offboarding',
      icon: icons.IconUserX,
      breadcrumbs: false
    },
    {
      id: 'inactive-employees',
      title: 'Inactive Employees',
      type: 'item',
      url: '/inactive-employees',
      icon: icons.IconUserMinus,
      breadcrumbs: false
    },
    {
      id: 'alumni-group',
      title: 'Alumni Group',
      type: 'item',
      url: '/alumni-group',
      icon: icons.IconSchool,
      breadcrumbs: false
    },
  );
}
// if (userRole === 'EMPLOYEE' || userRole === 'MANAGER' || userRole === 'HR' || userRole === 'DIRECTOR' ) {
// /*   employees.children.push(
//     {
//       id: 'ProjectsTimeManagement',
//       title: 'Projects Time',
//       type: 'item',
//       url: '/projects-time-management',
//       icon: icons.IconReport,
//       breadcrumbs: false
//     },
      
   
//   ); */
//   if (userRole === 'EMPLOYEE' ) {
//       employees.children.push(
       
//         {
//           id: 'default',
//           title: 'HR Staff',
//           type: 'item',
//           url: '/hr-staff',
//           icon: icons.IconReplaceUser,
//           breadcrumbs: false
//         }
//     );
//   }
// }
export default employees;
